<template>
  <div
    :class="[classes.marquee, shouldAnimate ? 'animate' : 'static']"
    ref="marqueeRef"
  >
    <span ref="marqueeTextRef"><slot /></span>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watchEffect } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { useDimensionSync } from "@fresh8/vue-utils/src/dimensionSync";

const useStyles = createUseStyles({
  marquee: {
    overflow: "hidden",
    boxSizing: "border-box",
    "-webkit-transform": "translateZ(0)",
    "&.animate span": {
      paddingLeft: "100%",
      /* show the marquee just outside the paragraph */
      willChange: "transform",
      animation: props => `$marquee ${props.animationTime}s linear infinite`,
      "-webkit-transform": "translateZ(0)",
      "&:hover": {
        animationPlayState: "paused"
      }
    },
    "&.static": {
      alignItems: "center"
    },

    "& span": {
      display: "inline-block",
      width: "max-content"
    }
  },
  "@keyframes marquee": {
    "0%": {
      transform: "translate(0, 0)"
    },
    "100%": {
      transform: "translate(-100%, 0)"
    }
  }
});

export default defineComponent({
  name: "Marquee",
  props: {
    animationTime: {
      type: Number,
      default: 10
    }
  },
  setup(props) {
    const marqueeRef = ref();
    const marqueeTextRef = ref();
    const shouldAnimate = ref(false);

    const { dimensions: marqueeBox } = useDimensionSync(marqueeRef);
    const { dimensions: marqueeText } = useDimensionSync(marqueeTextRef);

    watchEffect(() => {
      const marqueeTextWitdh =
        (marqueeTextRef.value &&
          marqueeText.value.width -
            parseInt(getComputedStyle(marqueeTextRef.value).paddingLeft)) ||
        0;

      if (marqueeBox.value.width < marqueeTextWitdh) {
        shouldAnimate.value = true;
      } else {
        shouldAnimate.value = false;
      }
    });

    const reativeStyles = computed(() => ({
      animationTime: props.animationTime
    }));

    const classes = useStyles(reativeStyles);
    return { classes, marqueeTextRef, marqueeRef, shouldAnimate };
  }
});
</script>
